"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _buttonControl = _interopRequireDefault(require("../button-control"));

var _Close = _interopRequireDefault(require("@insided/shared/icons/Close"));

var _Search = _interopRequireDefault(require("@insided/shared/icons/Search"));

var _helper = require("./helper");

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _classnames = _interopRequireDefault(require("classnames"));

var ICON_SIZE_DEFAULT = 16;

function handleSubmit(event, onSubmit) {
  event.preventDefault();
  var target = event.target;
  var input = target.querySelector('input');
  if (!input) return;
  var value = input.value.trim();
  if (!value) return;
  onSubmit(value);
}

var SearchBox = function SearchBox(_ref) {
  var _getInsidedData, _getInsidedData$topic;

  var value = _ref.value,
      placeholder = _ref.placeholder,
      onInput = _ref.onInput,
      _onSubmit = _ref.onSubmit,
      onClear = _ref.onClear,
      isModerationOverview = _ref.isModerationOverview,
      feature = _ref.feature,
      searchInputRef = _ref.searchInputRef,
      iconSize = _ref.iconSize;
  var inputClassName = (0, _classnames.default)((0, _defineProperty2.default)({
    'qa-search-box-filter': !feature
  }, "qa-search-box-filter-".concat(feature), feature));
  var isOldTopicModerationPage = typeof window !== 'undefined' && Boolean((_getInsidedData = (0, _insidedDataStorage.getInsidedData)('content')) === null || _getInsidedData === void 0 ? void 0 : (_getInsidedData$topic = _getInsidedData.topic) === null || _getInsidedData$topic === void 0 ? void 0 : _getInsidedData$topic.id);
  var searchIconSize = iconSize !== null && iconSize !== void 0 ? iconSize : ICON_SIZE_DEFAULT;
  return (0, _preact.h)("div", {
    className: "control-search-box"
  }, (0, _preact.h)("form", {
    onSubmit: function onSubmit(event) {
      return handleSubmit(event, _onSubmit);
    }
  }, isModerationOverview && (0, _preact.h)(_Search.default, {
    width: searchIconSize,
    height: searchIconSize
  }), (0, _preact.h)("input", {
    ref: searchInputRef,
    className: inputClassName,
    type: "text",
    value: value,
    placeholder: placeholder,
    maxLength: 500,
    onInput: onInput,
    onClick: function onClick() {
      if (isOldTopicModerationPage) (0, _helper.manuallyFocusElement)(inputClassName);
    }
  }), isModerationOverview && value && (0, _preact.h)(_Close.default, {
    className: "control-search-box_close-icon",
    width: 16,
    height: 16,
    onClick: onClear,
    role: "button",
    "aria-label": "Clear search",
    "aria-hidden": "false",
    focusable: "true",
    tabIndex: 0
  }), !isModerationOverview && (0, _preact.h)(_buttonControl.default, {
    variant: "primary",
    type: "submit",
    icon: (0, _preact.h)(_Search.default, {
      width: 16,
      height: 16
    })
  })));
};

var _default = SearchBox;
exports.default = _default;